export const menuPageList = [
    {
        title: "空基规划",
        content: {},
    },
    {
        title: "空基卫星",
        content: {},
    },
    {
        title: "共性应用支撑平台",
        content: {},
    },
    {
        title: "共性应用支撑服务系统",
        content: {},
    },
    {
        title: "项目大事记",
        content: {},
    },
    {
        title: "团队简介",
        content: {},
    },
]

export const ChroniclesDatas = [
    {
        year:2023,
        dataList:[
            {
                mouth:"6月",
                introduce:"6月6日-8日，中国科学院空天信息研究院在线上召开了国家民用空间基础设施陆地观测卫星共性应用支撑平台项目真实性检验站网专业仪器答疑会。培训会邀请冠层分析仪技术人员进行了网络培训，会上专业技术人员针对不同植被类型：草地、农田、林地，开展测量技术培训及答疑：2022年6月7日草地类型测量培训及答疑、2022年6月7日农田类型测量培训及答疑、2022年6月8日林地类型测量培训及答疑。",
                img:"images/Introduce/Chronicles/1.png"
            },
            {
                mouth:"4月",
                introduce:"4月22日-25日，中国科学院空天信息研究院在线上召开了国家民用空间基础设施陆地观测卫星共性应用支撑平台项目真实性检验站网专业仪器培训会。培训会邀请冠层分析仪技术人员进行了网络培训，会上专业技术人员对仪器的操作、保养、使用前后注意事项做了详细的讲解，会后项目组为参会人员颁发了培训合格证书。",
                img:"images/Introduce/Chronicles/2.png"
            },
        ]
    },
    {
        year:2022,
        dataList:[
            {
                mouth:"12月",
                introduce:"7月13,空基光谱仪器培训会议",
                img:"images/Introduce/Chronicles/3.png"
            },
            {
                mouth:"6月",
                introduce:"6月,土壤温湿度传感器室内定标全部完成",
                img:"images/Introduce/Chronicles/4.png"
            },
        ]
    },
    {
        year:2021,
        dataList:[
            {
                mouth:"11月",
                introduce:"7月13,空基光谱仪器培训会议",
                img:"images/Introduce/Chronicles/3.png"
            },
            {
                mouth:"6月",
                introduce:"6月,土壤温湿度传感器室内定标全部完成",
                img:"images/Introduce/Chronicles/4.png"
            },
        ]
    },
    {
        year:2020,
        dataList:[
            {
                mouth:"10月",
                introduce:"7月13,空基光谱仪器培训会议",
                img:"images/Introduce/Chronicles/3.png"
            },
            {
                mouth:"6月",
                introduce:"6月,土壤温湿度传感器室内定标全部完成",
                img:"images/Introduce/Chronicles/4.png"
            },
        ]
    },
    {
        year:2019,
        dataList:[
            {
                mouth:"9月",
                introduce:"7月13,空基光谱仪器培训会议",
                img:"images/Introduce/Chronicles/3.png"
            },
            {
                mouth:"6月",
                introduce:"6月,土壤温湿度传感器室内定标全部完成",
                img:"images/Introduce/Chronicles/4.png"
            },
        ]
    },
    {
        year:2018,
        dataList:[
            {
                mouth:"8月",
                introduce:"7月13,空基光谱仪器培训会议",
                img:"images/Introduce/Chronicles/3.png"
            },
            {
                mouth:"6月",
                introduce:"6月,土壤温湿度传感器室内定标全部完成",
                img:"images/Introduce/Chronicles/4.png"
            },
        ]
    },
]